/* This file is generated by Kubb. DO NOT EDIT MANUALLY. */

import type { SearchWebpushSubscriptionsMutationRequest } from './types/SearchWebpushSubscriptions.ts';
import type { Client } from '@kubb/plugin-client/clients/fetch';
import { searchWebpushSubscriptions } from './clients/searchWebpushSubscriptions.ts';

export class ApiClient {
  constructor(private readonly client: Client) {}

  searchWebpushSubscriptions(data: SearchWebpushSubscriptionsMutationRequest) {
    return searchWebpushSubscriptions(data, { client: this.client });
  }
}
